import { DataTableRow as RWMC, DataTableRowProps as RWMCProps } from "@rmwc/data-table"
import { HTMLAttributes, useCallback } from "react"
import omit from "lodash/omit"
import { callCSSFn, CSS, CSSFn, styled, StyleProps } from "../../styles"

export type DataTableRowProps = RWMCProps &
  HTMLAttributes<HTMLTableRowElement> & {
    actionValue?: unknown
    css?: CSSFn
    action?: (value: unknown, e?: React.MouseEvent<HTMLElement>) => void
  }
const Component = ({ actionValue, action, ...props }: DataTableRowProps) => {
  const onClick = useCallback(
    (e) => {
      if (!action) return
      action(actionValue, e)
    },
    [action, actionValue]
  )
  return <RWMC onClick={(e: any) => onClick(e)} {...omit(props, `css`)} />
}
Component.defaultProps = {
  actionValue: undefined,
  css: undefined,
  action: undefined,
}

export const DataTableRow = styled(Component)(
  (props: StyleProps & DataTableRowProps): CSS => ({
    border: `none`,
    cursor: props.action ? `pointer` : `default`,
    ...callCSSFn(props),
  })
)
